// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealDocumentEntity from './entities/appeal-document.json';
import appealDocumentMenu from '../pages/appeal-document/menu.json';
import appealDocumentFullForm from '../pages/appeal-document/forms/full.json';
import appealDocumentContextForm from '../pages/appeal-document/forms/context.json';
import appealDocumentMiniForm from '../pages/appeal-document/forms/mini.json';
import appealDocumentLookupForm from '../pages/appeal-document/forms/lookup.json';
import appealDocumentTableView from '../pages/appeal-document/views/table.json';
import appealDocumentCardsView from '../pages/appeal-document/views/cards.json';
import appealDocumentCalendarView from '../pages/appeal-document/views/calendar.json';
import appealDocumentDashboardView from '../pages/appeal-document/views/dashboard.json';

/** Тип запису «Документ звернення» зі сторінками пакета: меню, форми та подання з pages/appeal-document/. */
export const appealDocumentDefinition: IRecordTypeDefinition = {
  ...appealDocumentEntity,
  views: assembleViewSet({
      table: appealDocumentTableView,
      cards: appealDocumentCardsView,
      calendar: appealDocumentCalendarView,
      dashboard: appealDocumentDashboardView,
  }),
  form: appealDocumentFullForm,
  forms: { full: appealDocumentFullForm, context: appealDocumentContextForm, mini: appealDocumentMiniForm, lookup: appealDocumentLookupForm },
  menu: appealDocumentMenu,
} as IRecordTypeDefinition;
